import { render, staticRenderFns } from "./PermissionCell.vue?vue&type=template&id=cf848af4"
import script from "./PermissionCell.vue?vue&type=script&lang=js"
export * from "./PermissionCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports